var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as bitecs from "bitecs";
import { clone, cloneDeep } from "lodash";
import { pixiDrawComponents, canRegisterComponents, generateSystems, generateRunList, componentList, uiComponents, uiComponentsById, getIndex, componentIndexMap, componentsByCategory } from "../components/ComponentRegistry.js";
import { flags } from "../console/flags.js";
import { E as EntityType, S as SoundType } from "../enums-86f58524.js";
import { TypeSchema } from "../decorators/type.js";
import { EntityFactory } from "../entity/EntityFactory.js";
import { Persist } from "../persist/persist.js";
import { ByteArray } from "../utils/byteArray.js";
import { isVector2d, scaleVector2d } from "../utils/vector.js";
import { D as DescriptionSchema } from "../Description-c36d0b9a.js";
import { R as RandomSchema } from "../Random-b6daba3a.js";
import { S as SpatialMapSchema } from "../SpatialMap-56228ece.js";
import { P as ParentSchema } from "../Parent-b4f1af10.js";
import { UIService } from "../ui/UIService.js";
import { md5 } from "../utils/md5.js";
import { PhysicsSystem } from "../components/physics/Physics.js";
import { T as TimeDilationSchema } from "../TimeDilation-41a74cd7.js";
import { EntityTypeSchema } from "../components/entity/Types.js";
import "../components/types.js";
import "ajv";
import "../utils/clone.js";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "../Attach-abbbd93e.js";
import "../utils/windowSessionStorage.js";
import "../constants/index.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "../components/core/ListenEntityCreation.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../FrameRate-7ce72a03.js";
import "../Collisions-9e9492fb.js";
import "../Physics-8d447f7a.js";
const dt = (deltaTime, arg, scale = 1) => {
  if (arg === void 0) {
    return deltaTime * scale;
  }
  const _secondTime = scale !== 1 ? deltaTime / 1e3 * scale : deltaTime / 1e3;
  if (typeof arg === "number") {
    return arg * _secondTime;
  }
  if (isVector2d(arg)) {
    return scaleVector2d(arg, _secondTime);
  }
  return arg;
};
const increment = (deltaTime, current, max, delta) => {
  const next = current + dt(deltaTime, delta);
  if (next >= max) {
    return 0;
  }
  return next;
};
class GameModel {
  constructor(gameCoordinator, instance, seed, coreOverrides, state) {
    __publicField(this, "state");
    __publicField(this, "drawComponents", {});
    __publicField(this, "app");
    __publicField(this, "runList", {});
    __publicField(this, "timings", []);
    __publicField(this, "timingFrame", 0);
    __publicField(this, "entityCounter", 0);
    __publicField(this, "world");
    __publicField(this, "localNetIds");
    __publicField(this, "roomId", "");
    __publicField(this, "systems");
    __publicField(this, "coreEntity");
    __publicField(this, "running");
    __publicField(this, "destroyed");
    __publicField(this, "dt", (entity, arg) => {
      if (this.hasComponent(entity, "TimeDilation")) {
        return dt(this.frameDt, arg, this.getTypedUnsafe(entity, TimeDilationSchema).amount);
      }
      return dt(this.frameDt, arg);
    });
    __publicField(this, "ping", 0);
    __publicField(this, "frame", 0);
    __publicField(this, "frameDt", 0);
    __publicField(this, "timeElapsed", 0);
    __publicField(this, "paused", false);
    __publicField(this, "soundQueue", []);
    __publicField(this, "soundDequeue", []);
    __publicField(this, "getNextEntityId", () => {
      return this.entityCounter;
    });
    __publicField(this, "generateEntityData", (entityCount) => {
      canRegisterComponents(false);
      this.systems = generateSystems(this);
      this.runList = generateRunList(Object.values(this.systems));
      this.state.entityComponentArray = [];
      this.state.components = [];
      this.state.activeEntities = [];
      this.state.activeByComponent = [];
      this.state.availableEntities = [];
      for (let i = 0; i < entityCount; i++) {
        this.state.entityComponentArray.push(new ByteArray());
        const componentArray = [];
        for (let j = 0; j < componentList.length; j++) {
          componentArray.push(null);
        }
        this.state.components.push(componentArray);
      }
      for (let i = 0; i < componentList.length; ++i) {
        this.state.activeByComponent.push([]);
      }
    });
    __publicField(this, "copyComponentData", (entity, i, remapEntities = true) => {
      let componentData = {
        type: ""
      };
      const component = componentList[i];
      if (this.isBitecs(i)) {
        const bitecsComponent = {};
        const schema = componentList[i].schema;
        Object.keys(schema.store).forEach((bitecsKey) => {
          if (bitecsKey !== "__changes") {
            bitecsComponent[bitecsKey] = schema.store[bitecsKey][entity];
          }
        });
        componentData = {
          type: schema.__type,
          data: bitecsComponent
        };
      } else {
        const cloned = clone(this.state.components[entity][i]);
        delete cloned.type;
        componentData = {
          type: component.type,
          data: cloned
        };
      }
      if (remapEntities && component.schema.__entityTypes) {
        const entityKeys = Object.keys(component.schema.__entityTypes);
        entityKeys.forEach((entityKey) => {
          const entityValue = componentData.data[entityKey];
          if (entityValue) {
            componentData.data[entityKey] = {
              entities: clone(entityValue)
            };
          }
        });
      }
      return componentData;
    });
    __publicField(this, "queueSound", (sound, {
      volume = 1,
      position,
      filters,
      type = SoundType.DEFAULT
    } = {}) => {
      this.soundQueue.push({ sound, volume, position, filters, type });
    });
    __publicField(this, "dequeueSound", (sound) => {
      if (!this.soundDequeue.includes(sound)) {
        this.soundDequeue.push(sound);
      }
    });
    __publicField(this, "cloneEntity", (entity) => {
      var _a;
      const clonedEntity = this.addEntity();
      const entityData = this.state.entityComponentArray[entity];
      const children = ((_a = this.getTypedUnsafe(entity, ParentSchema)) == null ? void 0 : _a.children) ?? [];
      const childrenData = [];
      for (let i = 0; i < children.length; i++) {
        childrenData.push(this.cloneEntity(children[i]));
      }
      for (let i = 0; i < componentList.length; i++) {
        if (entityData.get(i)) {
          const cloned = clone(this.state.components[entity][i]);
          this.addComponent(clonedEntity, cloned.type, cloned);
          this.cleanupComponent(clonedEntity, cloned.type, true);
        }
      }
      if (childrenData.length) {
        const parentData = this.getTypedUnsafe(clonedEntity, ParentSchema);
        parentData.children = new Array(...childrenData);
      }
      return clonedEntity;
    });
    __publicField(this, "injectEntity", (entityData, entityMap) => {
      if (!entityMap) {
        entityMap = {};
        for (let i = 0; i < entityData.entities.length; i++) {
          entityMap[entityData.entities[i]] = this.addEntity();
        }
      }
      const entityId = entityMap[entityData.entityId];
      for (let i = 0; i < entityData.components.length; i++) {
        this.mapComponentEntites(entityData.components[i], entityMap);
        this.addComponent(entityId, entityData.components[i].type, entityData.components[i].data);
      }
      Object.values(entityData.children).forEach((childEntityData) => {
        this.injectEntity(childEntityData, entityMap);
      });
      return entityId;
    });
    __publicField(this, "ejectEntity", (entity, removeEjectedEntity = true) => {
      var _a, _b;
      const data = {
        entityType: EntityTypeSchema.store.entityType[entity],
        description: ((_a = this.getTypedUnsafe(entity, DescriptionSchema)) == null ? void 0 : _a.description) ?? "",
        entityId: entity,
        components: [],
        entities: [],
        children: {},
        hasChildren: false
      };
      const entityData = this.state.entityComponentArray[entity];
      const children = ((_b = this.getTypedUnsafe(entity, ParentSchema)) == null ? void 0 : _b.children) ?? [];
      for (let i = 0; i < children.length; i++) {
        const childEntity = this.ejectEntity(children[i], false);
        data.entities.push(...childEntity.entities);
        data.children[childEntity.entityId] = childEntity;
      }
      const components = [];
      for (let i = 0; i < componentList.length; i++) {
        if (entityData.get(i)) {
          const componentData = this.ejectComponent(entity, i);
          components.push(componentData);
        }
      }
      data.components = components;
      data.entities.push(entity);
      data.entities = data.entities.filter((e) => this.isActive(e));
      if (removeEjectedEntity) {
        this.removeEntity(entity, true);
      }
      data.hasChildren = !!children.length;
      return data;
    });
    __publicField(this, "ejectComponent", (entity, i) => {
      if (typeof i === "string") {
        i = componentList.findIndex((c) => c.type === i);
      }
      this.cleanupComponent(entity, i, true);
      const cloned = this.copyComponentData(entity, i);
      const activeIndex = this.state.activeByComponent[i].indexOf(entity);
      if (activeIndex > -1) {
        this.state.activeByComponent[i].splice(activeIndex, 1);
      }
      return cloned;
    });
    __publicField(this, "getEntityData", (entity) => {
      var _a;
      const data = {
        entityType: EntityTypeSchema.store.entityType[entity],
        description: this.hasComponent(entity, DescriptionSchema) ? this.getTypedUnsafe(entity, DescriptionSchema).description : "",
        components: {},
        id: entity,
        children: []
      };
      const entityData = this.state.entityComponentArray[entity];
      for (let i = 0; i < componentList.length; i++) {
        if (entityData.get(i)) {
          const component = this.copyComponentData(entity, i, false);
          data.components[component.type] = component;
        }
      }
      const children = ((_a = this.getTyped(entity, ParentSchema)) == null ? void 0 : _a.children) ?? [];
      for (let i = 0; i < children.length; i++) {
        data.children.push(this.getEntityData(children[i]));
      }
      return data;
    });
    __publicField(this, "logEntity", (entity, overrideDebug = false) => {
      var _a;
      const data = this.getEntityData(entity);
      if (flags.DEBUG || overrideDebug) {
        if (typeof window === "undefined") {
          console.log(JSON.stringify(data, null, 2));
        } else {
          console.log(data);
        }
        const stack = (_a = new Error().stack) == null ? void 0 : _a.split("\n").slice(2).join("\n").substring(4);
        console.log("Entity log " + stack);
      }
    });
    __publicField(this, "addEntity", () => {
      let entity = bitecs.addEntity(this.world);
      while (entity === void 0) {
        console.error("entity is undefined, trying again");
        entity = bitecs.addEntity(this.world);
      }
      this.state.activeEntities.push(entity);
      return entity;
    });
    __publicField(this, "removeEntity", (entity, includeChildren = false) => {
      var _a, _b, _c;
      if (includeChildren) {
        const children = ((_a = this.getTypedUnsafe(entity, ParentSchema)) == null ? void 0 : _a.children) ?? [];
        for (let i = 0; i < children.length; i++) {
          this.removeEntity(children[i], true);
        }
      }
      const viewport = this.gameCoordinator.pixiViewport;
      const index = this.state.activeEntities.indexOf(entity);
      if (index > -1) {
        this.state.activeEntities.splice(index, 1);
        this.state.limboEntities.push(entity);
        const mask = this.state.entityComponentArray[entity];
        for (let i = 0; i < componentList.length; i++) {
          if (mask.get(i)) {
            const typeString = componentList[i].type;
            const system = this.systems[typeString];
            if (system == null ? void 0 : system.cleanup) {
              system.cleanup(entity, this, false);
            }
            const uiComponent = uiComponents[uiComponentsById[i]];
            if (uiComponent && uiComponent.cleanup) {
              uiComponent.cleanup(UIService.getInstance(), entity, this, false);
            }
            if (this.drawComponents[typeString]) {
              (_c = (_b = this.drawComponents[typeString]).cleanup) == null ? void 0 : _c.call(_b, entity, this, viewport);
            }
            const activeIndex = this.state.activeByComponent[i].indexOf(entity);
            if (activeIndex > -1) {
              this.state.activeByComponent[i].splice(activeIndex, 1);
            }
            if (this.isBitecs(i)) {
              const schema = componentList[i].schema;
              Object.keys(schema.store).forEach((bitecsKey) => {
                schema.store[bitecsKey][entity] = 0;
              });
            }
            this.state.components[entity][i] = null;
            mask.set(i, false);
          }
        }
        this.state.entityComponentArray[entity] = new ByteArray();
      }
      bitecs.removeEntity(this.world, entity);
    });
    __publicField(this, "run", () => {
      var _a;
      this.running = true;
      const frame = this.frame % 60;
      let runlist = this.frame && frame === 0 && ((_a = this.runList[60]) == null ? void 0 : _a[0]) || (this.runList[frame] || this.runList[0])[0];
      for (let i = 0; i < runlist.length; i++) {
        this.runComponent(runlist[i]);
      }
      this.running = false;
    });
    __publicField(this, "runPredraw", () => {
      var _a;
      const frame = this.frame % 60;
      let runlist = this.frame && frame === 0 && ((_a = this.runList[60]) == null ? void 0 : _a[1]) || (this.runList[frame] || this.runList[0])[1];
      for (let i = 0; i < runlist.length; i++) {
        this.runComponent(runlist[i]);
      }
    });
    __publicField(this, "cleanup", () => {
      for (let i = 0; i < this.state.limboEntities.length; i++) {
        this.state.availableEntities.push(this.state.limboEntities[i]);
      }
      this.state.limboEntities = [];
      if (flags.PERFORMANCE_LOGS) {
        window.performanceUpdate(this.timings);
        this.timings = [];
      }
    });
    __publicField(this, "cleanupEntity", (entity) => {
      for (let i = 0; i < componentList.length; i++) {
        if (this.state.entityComponentArray[entity].get(i)) {
          this.cleanupComponent(entity, i, false);
        }
      }
    });
    __publicField(this, "cleanupComponent", (entity, type, ejecting = false) => {
      const index = getIndex(type);
      const typeString = componentList[index].type;
      const system = this.systems[typeString];
      if (system == null ? void 0 : system.cleanup) {
        system.cleanup(entity, this, ejecting);
      }
      const uiComponent = uiComponents[uiComponentsById[index]];
      if (uiComponent && uiComponent.cleanup) {
        uiComponent.cleanup(UIService.getInstance(), entity, this, ejecting);
      }
      const drawComponent = this.drawComponents[componentList[index].type];
      if (drawComponent && drawComponent.cleanup) {
        drawComponent.cleanup(entity, this, this.gameCoordinator.pixiViewport);
      }
    });
    __publicField(this, "isActive", (entity) => {
      return bitecs.entityExists(this.world, entity);
    });
    __publicField(this, "hasComponent", (entity, type) => {
      if (typeof entity !== "number") {
        return false;
      }
      const index = getIndex(type);
      return entity > -1 && this.state.entityComponentArray[entity].has(index);
    });
    __publicField(this, "getComponentSchema", (type) => {
      const index = getIndex(type);
      return componentList[index].schema;
    });
    __publicField(this, "setTyped", (entity, type, overrides) => {
      return this.addComponent(entity, type.__type, overrides);
    });
    __publicField(this, "addIfMissing", (entity, type, overrides) => {
      if (!this.hasComponent(entity, type)) {
        this.addComponent(entity, type, overrides);
      }
    });
    __publicField(this, "addTyped", (entity, type, overrides) => {
      return this.addComponent(entity, type.__type, overrides);
    });
    __publicField(this, "addComponent", (entity, type, overrides, skipInit = false) => {
      const index = getIndex(type);
      try {
        if (entity < 0) {
          throw new Error("Cannot set component on invalid entity");
        }
        this.state.entityComponentArray[entity].enable(index);
        if (!this.state.activeByComponent[index].includes(entity)) {
          this.state.activeByComponent[index].push(entity);
        }
        const ComponentSchema = componentList[index].schema;
        if (typeof ComponentSchema === "undefined") {
          overrides = {};
        } else {
          overrides = this.validateComponent(entity, ComponentSchema, overrides);
        }
        if (ComponentSchema == null ? void 0 : ComponentSchema.store) {
          bitecs.addComponent(this.world, ComponentSchema.store, entity);
          ComponentSchema.id = entity;
          Object.entries(overrides).forEach(([key, value]) => {
            ComponentSchema[key] = value;
          });
          const typeString2 = componentList[index].type;
          const system2 = this.systems[typeString2];
          if ((system2 == null ? void 0 : system2.init) && !skipInit) {
            system2.init(entity, this);
          }
          return;
        }
        if (!ComponentSchema) {
          this.state.components[entity][index] = new TypeSchema({
            type: componentList[index].type
          });
        } else {
          this.state.components[entity][index] = {
            ...overrides,
            type: componentList[index].type
          };
        }
        const typeString = componentList[index].type;
        const system = this.systems[typeString];
        if ((system == null ? void 0 : system.init) && !skipInit) {
          system.init(entity, this);
        }
      } catch (e) {
        console.error(e);
        console.error(entity, type, overrides);
        throw e;
      }
    });
    __publicField(this, "removeComponent", (entity, type) => {
      const index = getIndex(type);
      this.cleanupComponent(entity, index);
      this.state.entityComponentArray[entity].disable(index);
      const activeIndex = this.state.activeByComponent[index].indexOf(entity);
      if (activeIndex > -1) {
        this.state.activeByComponent[index].splice(activeIndex, 1);
      }
      this.state.components[entity][index] = null;
    });
    __publicField(this, "getCategory", (type) => {
      const index = getIndex(type);
      return componentList[index].category;
    });
    __publicField(this, "getBitecs", (entity, type) => {
      type.id = entity;
      return type;
    });
    __publicField(this, "isBitecs", (type) => {
      var _a;
      const index = getIndex(type);
      return !!((_a = componentList[index].schema) == null ? void 0 : _a.store);
    });
    __publicField(this, "getSystem", (type) => {
      let typeString = type == null ? void 0 : type.__type;
      if (!typeString) {
        const index = getIndex(type);
        typeString = componentList[index].type;
      }
      return this.systems[typeString];
    });
    __publicField(this, "getPixiSystem", (type) => {
      let typeString = type == null ? void 0 : type.__type;
      if (!typeString) {
        const index = getIndex(type);
        typeString = componentList[index].type;
      }
      return this.drawComponents[typeString];
    });
    __publicField(this, "getTypedUnsafe", (entity, type) => {
      return this.getComponent(entity, type.__type);
    });
    __publicField(this, "getTyped", (entity, type) => {
      return this.getComponent(entity, type.__type);
    });
    __publicField(this, "getComponentUnsafe", (entity, type) => {
      var _a;
      const index = getIndex(type);
      if ((_a = componentList[index].schema) == null ? void 0 : _a.store) {
        componentList[index].schema.id = entity;
        return componentList[index].schema;
      }
      return this.state.components[entity][index];
    });
    __publicField(this, "getComponent", (entity, type) => {
      var _a;
      const index = getIndex(type);
      if ((_a = componentList[index].schema) == null ? void 0 : _a.store) {
        componentList[index].schema.id = entity;
        return componentList[index].schema;
      }
      return this.state.components[entity][index];
    });
    __publicField(this, "getComponentIndex", (type) => {
      return componentIndexMap[type];
    });
    __publicField(this, "getComponentActives", (type) => {
      return this.state.activeByComponent[getIndex(type)];
    });
    __publicField(this, "getActivesByDescription", (description) => {
      const actives = this.getComponentActives("Description");
      return (actives == null ? void 0 : actives.filter((entity) => {
        return this.getTypedUnsafe(entity, DescriptionSchema).description === description;
      })) ?? [];
    });
    __publicField(this, "getComponentIdsByCategory", (entity, category) => {
      const result = [];
      if (!componentsByCategory[category]) {
        return result;
      }
      for (let i = 0; i < componentsByCategory[category].length; i++) {
        if (this.state.entityComponentArray[entity].has(componentsByCategory[category][i])) {
          result.push(componentsByCategory[category][i]);
        }
      }
      return result;
    });
    __publicField(this, "runComponent", (type) => {
      var _a;
      try {
        let time = 0;
        if (flags.PERFORMANCE_LOGS) {
          time = performance.now();
        }
        const index = getIndex(type);
        const component = componentList[index];
        const componentSystem = this.systems[type];
        const actives = this.state.activeByComponent[componentIndexMap[type]];
        if (componentSystem.runAll) {
          if (actives.length) {
            componentSystem.runAll(this);
          }
          if (flags.PERFORMANCE_LOGS) {
            this.timings.push({ type, time: performance.now() - time });
          }
          return;
        }
        for (let i = 0; i < actives.length; ++i) {
          const length = actives.length;
          (_a = componentSystem.run) == null ? void 0 : _a.call(componentSystem, actives[i], this);
          if (length !== actives.length) {
            i--;
          } else if (flags.DEBUG && typeof component.schema === "function") {
            const data = this.state.components[actives[i]][index];
            if (!component.schema.__validate(data)) {
              console.error("Validation Error");
              console.error(component.schema.__validate.errors);
              console.error(
                data,
                // @ts-ignore
                component.schema.__schema
              );
              this.logEntity(actives[i], true);
              throw new Error(`Invalid schema for component ${type} on entity ${actives[i]}`);
            }
          }
        }
        if (flags.PERFORMANCE_LOGS) {
          this.timings.push({ type, time: performance.now() - time });
        }
      } catch (e) {
        console.error(e);
        console.error(type);
        throw e;
      }
    });
    __publicField(this, "runPixiComponents", () => {
      const viewport = this.gameCoordinator.pixiViewport;
      for (let i = 0; i < pixiDrawComponents.length; i++) {
        const pixi = pixiDrawComponents[i];
        if (pixi.id === -1) {
          pixi.id = this.getComponentIndex(pixi.type);
        }
        const actives = this.state.activeByComponent[pixi.id];
        const drawComponent = this.drawComponents[pixi.type];
        if (drawComponent.debug && !flags.DEBUG) {
          for (let i2 = 0; i2 < actives.length; ++i2) {
            if (drawComponent.ids.has(actives[i2])) {
              drawComponent.cleanup(actives[i2], this, viewport);
            }
          }
          continue;
        }
        for (let j = 0; j < actives.length; j++) {
          const entity = actives[j];
          if (drawComponent.ids && !drawComponent.ids.has(entity)) {
            drawComponent.init(actives[j], this, viewport);
          }
          drawComponent.run(actives[j], this, viewport);
        }
      }
    });
    __publicField(this, "getDependencies", (type) => {
      var _a;
      return ((_a = this.systems[type]) == null ? void 0 : _a.dependencies) ?? [];
    });
    __publicField(this, "getDepth", (type) => {
      const index = getIndex(type);
      return componentList[index].depth;
    });
    __publicField(this, "runUIComponents", () => {
      const uiService = UIService.getInstance();
      for (let i = 0; i < uiComponents.length; i++) {
        const uiComponent = uiComponents[i];
        if (uiComponent.id === -1) {
          uiComponent.id = this.getComponentIndex(uiComponent.type);
        }
        if (uiComponentsById[uiComponent.id] === void 0) {
          uiComponentsById[uiComponent.id] = i;
        }
        let actives = this.state.activeByComponent[uiComponent.id];
        if (uiComponent.sort) {
          actives = actives.concat().sort((a, b) => uiComponent.sort(a, b, this));
        }
        for (let j = 0; j < actives.length; j++) {
          const entity = actives[j];
          if (uiComponent.debug && !flags.DEBUG) {
            continue;
          }
          try {
            uiComponent.system(uiService, entity, this, this.gameCoordinator.pixiViewport);
          } finally {
          }
        }
      }
    });
    __publicField(this, "mapComponentEntites", (component, entityMap) => {
      const componentData = (component == null ? void 0 : component.data) ?? component;
      const componentId = this.getComponentIndex(component.type);
      if (componentList[componentId].schema.__entityTypes) {
        const entityKeys = Object.keys(componentList[componentId].schema.__entityTypes);
        entityKeys.forEach((entityKey) => {
          const entityValue = componentData[entityKey];
          if (entityValue) {
            if (Array.isArray(entityValue.entities)) {
              componentData[entityKey] = entityValue.entities.map(
                (e) => e !== -1 && e !== null ? entityMap[e] : e
              );
            } else {
              componentData[entityKey] = typeof entityValue.entities === "number" && entityValue.entities > -1 ? entityMap[entityValue.entities] : entityValue.entities;
            }
          }
        });
      }
    });
    var _a;
    this.gameCoordinator = gameCoordinator;
    this.instance = instance;
    this.state = state || {
      type: "internal",
      entityComponentArray: [],
      components: [],
      activeEntities: [],
      limboEntities: [],
      availableEntities: [],
      activeByComponent: []
    };
    this.world = bitecs.createWorld();
    pixiDrawComponents.sort((a, b) => a.zIndex - b.zIndex);
    pixiDrawComponents.forEach((drawComponent) => {
      this.drawComponents[drawComponent.type] = new drawComponent.system();
    });
    if (state) {
      return;
    }
    this.generateEntityData(1e4);
    this.app = gameCoordinator.pixiApp;
    this.coreEntity = EntityFactory.getInstance().generateEntity(this, "core", {
      ...coreOverrides,
      Random: {
        seed: seed ?? ""
      }
    });
    const physicsSystem = this.getSystem(PhysicsSystem);
    (_a = physicsSystem == null ? void 0 : physicsSystem.getEngine) == null ? void 0 : _a.call(physicsSystem, this);
  }
  get spatialMap() {
    return this.getTypedUnsafe(this.coreEntity, SpatialMapSchema).spatialMap;
  }
  get rand() {
    return this.getTypedUnsafe(this.coreEntity, RandomSchema).random;
  }
  get players() {
    return this.getComponentActives("PlayerType") ?? [];
  }
  get enemies() {
    return this.getComponentActives("EnemyType");
  }
  get pickups() {
    return this.getComponentActives("PickupType");
  }
  get projectiles() {
    return this.getComponentActives("ProjectileType");
  }
  get walls() {
    return this.getComponentActives("WallType");
  }
  get doors() {
    return this.getComponentActives("DoorType");
  }
  get interactables() {
    return this.getComponentActives("InteractableType");
  }
  increment(entity, current, max, delta) {
    if (this.hasComponent(entity, "TimeDilation")) {
      return increment(this.frameDt, current, max, delta * this.getTypedUnsafe(entity, TimeDilationSchema).amount);
    }
    return increment(this.frameDt, current, max, delta);
  }
  getEntities(entityType) {
    if (entityType !== void 0) {
      if (!Array.isArray(entityType)) {
        entityType = [entityType];
      }
      return entityType.map((type) => {
        switch (type) {
          case EntityType.PLAYER:
            return this.players;
          case EntityType.ALLY:
            return this.getComponentActives("AllyType") ?? [];
          case EntityType.ENEMY:
            return this.enemies;
          case EntityType.PROJECTILE:
            return this.projectiles;
          case EntityType.PICKUP:
            return this.pickups;
          case EntityType.WALL:
            return this.walls;
          case EntityType.INTERACTABLE:
            return this.interactables;
        }
        return [];
      }).flat();
    }
    return this.entities;
  }
  get entities() {
    return [...this.players, ...this.enemies, ...this.pickups, ...this.projectiles, ...this.walls];
  }
  getEntityByDescription(description) {
    const entities = this.getComponentActives("Description");
    return entities == null ? void 0 : entities.filter((entity) => {
      const desc = this.getTypedUnsafe(entity, DescriptionSchema);
      return desc.description === description;
    });
  }
  validateComponent(entity, ComponentSchema, overrides) {
    overrides = overrides || {};
    Object.entries(overrides).forEach(([key, value]) => {
      if (typeof value === "object" && (value == null ? void 0 : value.toJSON)) {
        overrides[key] = value.toJSON();
      }
    });
    if (!ComponentSchema.__validate(overrides)) {
      console.error("Validation Error");
      console.error(
        overrides,
        // @ts-ignore
        ComponentSchema.__schema
      );
      console.error(ComponentSchema.__validate.errors);
      throw new Error(`Invalid schema for component ${ComponentSchema.__type} on entity ${entity}`);
    }
    return overrides;
  }
  defineQuery(schema) {
    return bitecs.defineQuery((Array.isArray(schema) ? schema : [schema]).map((s) => s.store));
  }
  isOf(entity, type) {
    if (this.hasComponent(entity, "Description")) {
      return this.getTypedUnsafe(entity, DescriptionSchema).description === type;
    }
    return false;
  }
  serializeState() {
    const state = this.state;
    const activesEntities = cloneDeep(state.activeEntities);
    const saveObject = activesEntities.reduce((acc, entity) => {
      const components = state.components[entity];
      const entityComponentArray = state.entityComponentArray[entity];
      acc[entity] = {};
      entityComponentArray.bytes.forEach((componentId) => {
        if (this.isBitecs(componentId)) {
          const bitecsComponent = {};
          const schema = componentList[componentId].schema;
          Object.keys(schema.store).forEach((bitecsKey) => {
            if (bitecsKey !== "__changes") {
              bitecsComponent[bitecsKey] = schema.store[bitecsKey][entity];
            }
          });
          bitecsComponent.type = schema.__type;
          acc[entity][componentId] = bitecsComponent;
        } else {
          if (!components[componentId].type) {
            console.log(components[componentId], componentList[componentId].type);
            components[componentId].type = componentList[componentId].type;
          }
          acc[entity][componentId] = clone(components[componentId]);
        }
        if (componentList[componentId].schema.__entityTypes) {
          const entityKeys = Object.keys(componentList[componentId].schema.__entityTypes);
          entityKeys.forEach((entityKey) => {
            const entityValue = acc[entity][componentId][entityKey];
            if (entityValue) {
              acc[entity][componentId][entityKey] = {
                entities: clone(entityValue)
              };
            }
          });
        }
      });
      return acc;
    }, {});
    return {
      core: this.coreEntity,
      timeElapsed: this.timeElapsed,
      frame: this.frame,
      frameDt: this.frameDt,
      entities: saveObject
    };
  }
  async saveState(id) {
    const saveObject = this.serializeState();
    const save = {
      id,
      state: saveObject
    };
    await Persist.getInstance().set(id, save);
  }
  async removeSave(id) {
    await Persist.getInstance().remove(id);
  }
  async loadState(id) {
    const save = await Persist.getInstance().get(id);
    if (save) {
      this.loadStateObject(save.state);
    }
  }
  clearState() {
    for (let i = this.state.activeEntities.length; i >= 0; i--) {
      if (this.isActive(this.state.activeEntities[i]) && this.state.activeEntities[i] !== this.coreEntity) {
        this.removeEntity(this.state.activeEntities[i]);
      }
    }
    this.removeEntity(this.coreEntity);
    bitecs.deleteWorld(this.world);
    this.world = bitecs.createWorld(1e4);
    this.generateEntityData(1e4);
  }
  loadStateObject(saveObject) {
    var _a, _b;
    this.clearState();
    const state = this.state;
    const entities = Object.keys(saveObject.entities).map((e) => parseInt(e, 10));
    const largest = Math.max(...entities);
    const entityMap = {};
    for (let i = 0; i <= largest; i++) {
      const newEntity = this.addEntity();
      if (saveObject.entities[newEntity]) {
        entityMap[newEntity] = newEntity;
      }
    }
    this.coreEntity = entityMap[saveObject.core];
    const generateEntity = (entity) => {
      const components = saveObject.entities[entity];
      const componentIds = Object.keys(components).map((c) => parseInt(c, 10));
      const newEntity = entityMap[entity];
      componentIds.forEach((componentId) => {
        state.activeByComponent[componentId].push(newEntity);
        state.entityComponentArray[newEntity].set(componentId, true);
        if (componentList[componentId].schema.__entityTypes) {
          const entityKeys = Object.keys(componentList[componentId].schema.__entityTypes);
          entityKeys.forEach((entityKey) => {
            const entityValue = components[componentId][entityKey];
            if (entityValue) {
              if (Array.isArray(entityValue.entities)) {
                components[componentId][entityKey] = entityValue.entities.map(
                  (e) => e !== -1 && e !== null ? entityMap[e] : e
                );
              } else {
                components[componentId][entityKey] = typeof entityValue.entities === "number" && entityValue.entities > -1 ? entityMap[entityValue.entities] : entityValue.entities;
              }
            }
          });
        }
        if (!this.isBitecs(componentId)) {
          state.components[newEntity][componentId] = components[componentId];
        } else {
          const schema = componentList[componentId].schema;
          const bitecsComponent = components[componentId];
          bitecs.addComponent(this.world, schema.store, newEntity);
          schema.id = entity;
          Object.keys(schema.store).forEach((bitecsKey) => {
            if (bitecsKey !== "__changes" && bitecsComponent[bitecsKey] !== void 0) {
              schema.store[bitecsKey][newEntity] = bitecsComponent[bitecsKey];
            }
          });
        }
      });
    };
    generateEntity(saveObject.core);
    entities.forEach((entity) => entity !== saveObject.core && generateEntity(entity));
    this.state = state;
    this.frame = saveObject.frame;
    this.frameDt = saveObject.frameDt;
    this.timeElapsed = saveObject.timeElapsed;
    const physicsSystem = this.getSystem(PhysicsSystem);
    (_a = physicsSystem == null ? void 0 : physicsSystem.getEngine) == null ? void 0 : _a.call(physicsSystem, this);
    var uint8array = (_b = physicsSystem.world) == null ? void 0 : _b.takeSnapshot();
    var string = new TextDecoder().decode(uint8array);
    const md5String = md5(string);
    console.log(md5String);
  }
  destroy(clearUI = true) {
    this.clearState();
    if (clearUI) {
      UIService.getInstance().clearUI();
    }
    this.destroyed = true;
  }
}
export {
  GameModel
};
//# sourceMappingURL=GameModel.js.map
